import DotLoader from './DotLoader';

export { DotLoader };
